import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import CheckInimg from "../../../images/CheckInimg.png";
import {
    Form, Button, Container, Row, Col, Card, Navbar,
} from "react-bootstrap";
import "./Vendormaster.css";
import {useForm} from "react-hook-form";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "../../util/Axios/AxiosInstance";

function VendorMaster({HandleEvent}) {
    const {
        register, handleSubmit, formState: {errors},
    } = useForm();
    const onSubmit = (data) => {
    };
    const [showV, setShowV] = useState(false);
    const [showMsgV, setShowMsgV] = useState("");
    const handleClose = () => setShowV(false);
    const handleBack = (e) => {
        e.preventDefault();
        HandleEvent(1);
    };
    const handleShow = (e) => {
        e.preventDefault();
        setShowV(true);
    };
    //const showSuccessMsgV = () => setShowMsgV(true);

    // const [id, setId] = useState("");
    const [branch, setBranch] = useState(localStorage.getItem("branch"));
    const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
    const [contractName, setContractName] = useState("");
    const [vendorName, setVendorName] = useState("");
    const [vendorDob, setVendorDob] = useState("");
    const [contractorAge, setContractAge] = useState("");
    const [gender, setGender] = useState("");
    const [address, setAddress] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [email, setEmail] = useState("");
    const [altEmail, setAltEmail] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    // const [mobileNumber, setMobileNumber] = useState("");
    const [altNumber, setAltNumber] = useState("");
    const [sac, setSac] = useState("");
    const [esi, setEsi] = useState("");
    const [pfEstablishmentNumber, setPfEstablishmentNumber] = useState("");
    const [gstNumber, setGstNumber] = useState("");
    const [bankState, setBankState] = useState("");
    const [bankName, setBankName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscCode, setIfscCode] = useState("");
    const [branchName, setBranchName] = useState("");
    const [contractSupervisorName, setContractSupervisorName] = useState("");
    const [supervisorContactNo, setSupervisorContactNo] = useState("");
    const [supervisorEmail, setSupervisorEmail] = useState("");
    const [error, setError] = useState("");
    const [branchList, setBranchList] = useState([{id: "", branchId: "", branchName: ""},]);

    const errorCheck = async (e) => {
        if (contractName.trim().length == 0 || vendorName.trim().length == 0 || contractorAge <= 20 || contractorAge >= 70 || (gender != "male" && gender != "female") || address.trim().length == 0 || pinCode.length != 6 || contactNumber.length != 10 || altNumber === contactNumber || email.length == 0 || altEmail === email || sac.trim().length <= 0 || esi.trim().length == 0 || pfEstablishmentNumber.trim().length == 0 || gstNumber.trim().length == 0 || bankState.trim().length == 0 || bankName.trim().length == 0 || accountNumber.length < 5 || accountNumber.length > 18 || ifscCode.trim().length == 0 || branchName.trim().length == 0 || contractSupervisorName.trim().length == 0 || !supervisorContactNo.match("[0-9]") || supervisorContactNo.length != 10 || supervisorEmail.trim().length <= 0) {
            setError(true);
            window.scrollTo({
                top: 0, behavior: "smooth",
            });
        } else {
            handleClickConfirm(e);
        }
    };

    const handleClickConfirm = (e) => {
        confirmAlert({
            title: <p className="alertTitle">Confirm to submit</p>, message: (<p className="alertMessage">
                Click on Proceed to Save the Vendor Details
            </p>), buttons: [{
                label: "Proceed", onClick: () => handleSubmitForm(e),
            }, {
                label: "Cancel",
            },],
        });
    };

    const sucessMessage = () => {
        confirmAlert({
            title: <p className="alertTitle">Updated Successfully</p>,
            message: <img src={CheckInimg} className="successImg" alt=""/>,
            buttons: [{
                label: "Close Page",
            },],
        });
        HandleEvent(1);
    };

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        // if(contractName.trim().length ==0 || vendorName.trim().length ==0 || (contractorAge <= 20 || contractorAge >=70) || (gender != "male" && gender != "female") ||
        // address.trim().length ==0 || pinCode.length != 6 || contactNumber.length != 10 || altNumber===contactNumber ||
        // email.length ==0 || altEmail===email || sac.trim().length<=0 || esi.trim().length==0 || pfEstablishmentNumber.trim().length==0 ||
        // gstNumber.trim().length==0 || bankState.trim().length==0 || bankName.trim().length==0 || (accountNumber.length < 5 || accountNumber.length >15) ||
        // ifscCode.trim().length==0 || branchName.trim().length==0 || contractSupervisorName.trim().length==0 || !supervisorContactNo.match('[0-9]') || supervisorContactNo.length != 10
        // || supervisorEmail.trim().length<=0 ){
        //   setError(true);
        // }
        // else{

        let addVendormaster = {
            // id: id,
            // branch: branch,
            branchId: branchId,
            contractName: contractName,
            vendorName: vendorName,
            vendorDob: vendorDob,
            contractorAge: contractorAge,
            gender: gender,
            address: address,
            pinCode: pinCode,
            contactNumber: contactNumber,
            altNumber: altNumber,
            email: email,
            altEmail: altEmail,
            sac: sac,
            esi: esi,
            pfEstablishmentNumber: pfEstablishmentNumber,
            gstNumber: gstNumber,
            bankState: bankState,
            bankName: bankName,
            accountNumber: accountNumber,
            ifscCode: ifscCode,
            branchName: branchName,
            contractSupervisorName: contractSupervisorName,
            supervisorContactNo: supervisorContactNo,
            supervisorEmail: supervisorEmail, // bank_state: bank_state,
            // bank_name: bank_name,
            // contract_supervisor_name: contract_supervisor_name,
            // supervisor_contact_no: supervisor_contact_no,
            // supervisor_email: supervisor_email
        }

        axios.post("addVendorMasterDetails", addVendormaster)
            .then((data) => {
                sucessMessage();
                setShowMsgV(true);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const calculate_age = (dob) => {
        var today = new Date();
        var birthDate = new Date(dob);
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        setContractAge(age_now);
    };

    // const onSelectBranch = (e) => {
    //
    //
    //
    //   setBranchId(e.target.value);
    //   setBranch(e.target.selectedOptions[0].id);
    // };

    const onSelectDOB = (e) => {
        setVendorDob(e.target.value);
        calculate_age(e.target.value);
    };

    useEffect(() => {
        AOS.init();
    }, [])

    return (<div>
        <Container fluid className="px-0">
            <div className="">
                <div className={"mt-2"}>
                    <h5 className={"priColor"}>Vendor Master</h5>
                </div>
                <div data-aos="zoom-in-right" data-aos-duration="450">
                    <Form>
                        <Card className="cardStyl">
                            <Navbar bg="white" className="mb-3">
                                <Container fluid className="px-0">
                                    <Navbar.Brand style={{fontWeight: "500"}}>
                                        Personal Information
                                    </Navbar.Brand>
                                    <Navbar.Toggle/>
                                </Container>
                            </Navbar>
                            <div>
                                {/* <Row className='mb-3'>
                  <Col md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column lg={4} className="labelRight">
                        Branch<sup className="required">*</sup>
                      </Form.Label>
                      <Col lg={8}>
                        <Form.Select
                          // name={deptList}
                            placeholder={"Select Branch"}
                          onChange={(e) => onSelectBranch(e)}
                          //value={branchList}
                        >
                          <option key={"defaultOption"} value={"defaultOption"}>Select Branch</option>
                          {branchList.map(branch => (
                            <option
                              key={branch.branchId}
                              value={branch.branchId}
                              id={branch.branchName}
                            >
                              {branch.branchName}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (branch == "defaultOption")?
                        <label className="requiredValidation">Please Select Branch </label>:""}
                        {/* {errors.Dept && (
                          <p className="RequiredFields">Please Select Dept</p>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contract Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setContractName(e.target.value)}
                                                    value={contractName}
                                                    //{...register("contractName", { required: true, maxLength: 30 })}
                                                />
                                                {error && contractName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Contract Name Can't be empty
                                                    </label>) : ("")}
                                                {/* {errors.contractName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Contract Name</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contractor Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setVendorName(e.target.value)}
                                                    value={vendorName}
                                                    // {...register("contractorName", { required: true, maxLength: 30 })}
                                                />
                                                {error && vendorName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Vendor/Contractor Name Can't be empty
                                                    </label>) : ("")}
                                                {/* {errors.contractorName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Contractor Name</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contractor DOB<sup className="required">*</sup>
                                            </Form.Label>

                                            <Col>
                                                <Form.Control
                                                    type="date"
                                                    min="1923-01-01"
                                                    max="2000-12-31"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => onSelectDOB(e)}
                                                    value={vendorDob}
                                                    // {...register("contractorDOB", { required: true, pattern: /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/([0-9]{4})$/ })}
                                                />
                                                {error && (contractorAge <= 20 || contractorAge >= 70) ? (
                                                    <label className="requiredValidation">
                                                        Please Select Valid DOB
                                                    </label>) : ("")}
                                                {/* {errors.contractorDOB && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Contractor DOB</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contractor Age<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    disabled
                                                    type="text"
                                                    placeholder="Age"
                                                    value={contractorAge}
                                                    onChange={(e) => setContractAge(e.target.value)}
                                                    // {...register("contractorAge", { required: true })}
                                                />
                                                {/* {errors.contractorAge && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Contractor Age Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Form.Group as={Row}>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Gender<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col className="mt-2">
                                                <div className="inlineflex">
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="male"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 1"
                                                            label="Male"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="mrgnGender">
                                                        <Form.Check
                                                            value="female"
                                                            type="radio"
                                                            name="gender"
                                                            aria-label="radio 2"
                                                            label="Female"
                                                            onChange={(e) => setGender(e.target.value)}
                                                        />
                                                    </div>
                                                    {" "}
                                                    {/* <div className="mrgnGender">

                            <Form.Check
                              value="other"
                              type="radio"
                              name="gender"
                              aria-label="radio 3"
                              label="Other"
                              onChange={(e) => setGender(e.target.value)}
                            />
                           {" "}
                          </div> */}{" "}
                                                </div>
                                                {/* {errors.gender && (gender != "male" || gender != "female")(
                          <p className="validationMsg valdiationMsgAlign">
                            Select the Gender
                          </p>
                        )}{" "} */}
                                                {error && gender != "male" && gender != "female" ? (
                                                    <label className="requiredValidation">
                                                        Please Select Gender
                                                    </label>) : ("")}
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                    {/* <Col    md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Address</Form.Label>
                      <Col>
                        <Form.Control type="text" placeholder="Enter here.." />
                      </Col>
                    </Row>
                  </Col> */}
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Address<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                          <textarea
                              className="form-control"
                              placeholder="Enter here.."
                              onChange={(e) => setAddress(e.target.value)}
                              value={address}
                              //{...register("address", { required: true })}
                          />
                                                {error && address.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Address
                                                    </label>) : ("")}
                                                {/* {errors.address && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Address is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Pincode<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    maxLength={6}
                                                    minLength={6}
                                                    onChange={(e) => setPinCode(e.target.value)}
                                                    value={pinCode}
                                                    // {...register("pincode", { required: true, pattern: /^[1-9]{1}[0-9]{2}\\s{0, 1}[0-9]{3}$/ })}
                                                />
                                                {error && pinCode.length != 6 ? (<label className="requiredValidation">
                                                    Please Enter Valid Pincode
                                                </label>) : ("")}
                                                {/* {errors.pincode && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Pincode</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contact Number<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    minLength={10}
                                                    maxLength={10}
                                                    onChange={(e) => setContactNumber(e.target.value)}
                                                    value={contactNumber}
                                                    // {...register("contactNumber", { required: true, pattern: /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[789]\d{9}$/ })}
                                                />
                                                {error && contactNumber.length != 10 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Mobile No.
                                                    </label>) : ("")}
                                                {/* {errors.contactNumber && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Contact Number</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Number{" "}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    minLength={10}
                                                    maxLength={10}
                                                    onChange={(e) => setAltNumber(e.target.value)}
                                                    value={altNumber}
                                                    //{...register("alternativeNumber", { required: false, pattern: /^(?:(?:\\+|0{0,2})91(\s*[\\-]\s*)?|[0]?)?[789]\d{9}$/ })}
                                                />
                                                {error && altNumber === contactNumber && contactNumber.length === 10 ? (
                                                    <label className="requiredValidation">
                                                        This Number was already Provided in "Contact
                                                        Number", Please Enter New Number or Make it empty.
                                                    </label>) : ("")}
                                                {/* {errors.alternativeNumber && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Alternative Number</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Email Id<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    value={email}
                                                    //{...register("emailId", { required: true, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ })}
                                                />
                                                {error && email.length <= 0 ? (<label className="requiredValidation">
                                                    Please Enter Valid Email Id
                                                </label>) : ("")}
                                                {/* {errors.emailId && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Email Id</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Alternative Email Id{" "}
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setAltEmail(e.target.value)}
                                                    value={altEmail}
                                                    // {...register("alternativeEmailId", { required: false, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ })}
                                                />
                                                {error && email === altEmail && email.length !== 0 ? (
                                                    <label className="requiredValidation">
                                                        This Id was already Provided in "Email Id", Please
                                                        enter another Id or make it empty.{" "}
                                                    </label>) : ("")}
                                                {/* {errors.alternativeEmailId && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the Alternative Email Id</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                SAC(Services Accounting Codes)
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setSac(e.target.value)}
                                                    value={sac}
                                                    // {...register("sac(ServicesAccountingCodes)", { required: true })}
                                                />
                                                {error && sac.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter SAC{" "}
                                                    </label>) : ("")}
                                                {/* {errors.sacServicesAccountingCodes && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>SAC(Services Accounting Codes) is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                ESI NO<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setEsi(e.target.value)}
                                                    value={esi}
                                                    // {...register("esiNo", { required: true })}
                                                />
                                                {error && esi.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter ESI Number{" "}
                                                    </label>) : ("")}
                                                {/* {errors.esiNo && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>ESI No is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                PF Establishment Number
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setPfEstablishmentNumber(e.target.value)}
                                                    value={pfEstablishmentNumber}
                                                    // {...register("pfEstablishmentNumber", { required: true })}
                                                />
                                                {error && pfEstablishmentNumber.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter PF Establishment Number{" "}
                                                    </label>) : ("")}
                                                {/* {errors.pfEstablishmentNumber && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>PF Establishment Number is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                GST Number<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setGstNumber(e.target.value)}
                                                    value={gstNumber}
                                                    //  {...register("gstNo", { required: true })}
                                                />
                                                {error && gstNumber.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter GST Number{" "}
                                                    </label>) : ("")}
                                                {/* {errors.gstNo && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>GST Number is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank State<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankState(e.target.value)}
                                                    value={bankState}
                                                    //{...register("bankState", { required: true })}
                                                />
                                                {error && bankState.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Bank State{" "}
                                                    </label>) : ("")}
                                                {/* {errors.bankState && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Bank State is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Bank Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBankName(e.target.value)}
                                                    value={bankName}
                                                    //  {...register("bankName", { required: true })}
                                                />
                                                {error && bankName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Bank Name Can't be Empty{" "}
                                                    </label>) : ("")}
                                                {/* {errors.bankName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Bank Name is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Account Number<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setAccountNumber(e.target.value)}
                                                    value={accountNumber}
                                                    //  {...register("accountNo", { required: true })}
                                                />
                                                {error && (accountNumber.length < 5 || accountNumber.length > 18) ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Account Number
                                                    </label>) : ("")}
                                                {/* {errors.accountNo && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Account Number is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                IFSC Code<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setIfscCode(e.target.value)}
                                                    value={ifscCode}
                                                    //  {...register("ifscCode", { required: true })}
                                                />
                                                {error && ifscCode.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter IFSC Code{" "}
                                                    </label>) : ("")}
                                                {/* {errors.ifscCode && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>IFSC Code is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Branch Name<sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setBranchName(e.target.value)}
                                                    value={branchName}
                                                    //  {...register("branchName", { required: true })}
                                                />
                                                {error && branchName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Branch Name{" "}
                                                    </label>) : ("")}
                                                {/* {errors.branchName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Branch Name is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Contract Supervisor Name
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter here.."
                                                    onChange={(e) => setContractSupervisorName(e.target.value)}
                                                    value={contractSupervisorName}
                                                    //  {...register("contractSupervisorName", { required: true })}
                                                />
                                                {error && contractSupervisorName.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Supervisor Name{" "}
                                                    </label>) : ("")}
                                                {/* {errors.contractSupervisorName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Contract Supervisor Name is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Supervisor Contact Number{" "}
                                                <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter here.."
                                                    maxLength={10}
                                                    minLength={10}
                                                    onChange={(e) => setSupervisorContactNo(e.target.value)}
                                                    value={supervisorContactNo}
                                                    //  {...register("contractSupervisorName", { required: true })}
                                                />
                                                {error && supervisorContactNo.length !== 10 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Contact Number
                                                    </label>) : ("")}
                                                {/* {errors.contractSupervisorName && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Contract Supervisor Name is Required</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={6} sm={12} xl={6} lg={6}>
                                        <Row>
                                            <Form.Label
                                                column
                                                md={4}
                                                sm={4}
                                                xl={4}
                                                lg={4}
                                                className="labelRight"
                                            >
                                                Supervisor Mail Id <sup className="required">*</sup>
                                            </Form.Label>
                                            <Col>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="name@example.com"
                                                    onChange={(e) => setSupervisorEmail(e.target.value)}
                                                    value={supervisorEmail}
                                                    // {...register("mailId", { required: true, pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/ })}
                                                />
                                                {error && supervisorEmail.trim().length <= 0 ? (
                                                    <label className="requiredValidation">
                                                        Please Enter Valid Email address{" "}
                                                    </label>) : ("")}
                                                {/* {errors.mailId && <p className='validationMsg valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign valdiationMsgAlign'>Please Check the mail Id</p>} */}
                                            </Col>
                                        </Row>
                                    </Col>

                                    {/* <Col    md={6} sm={12} xl={6} lg={6}>
                    <Row>
                      <Form.Label column md={4} sm={4} xl={4} lg={4} className="labelRight">Contract Supervisor Name</Form.Label>
                      <Col>
                        <Form.Control type="text" placeholder="Enter here.." />
                      </Col>
                    </Row>
                  </Col> */}
                                </Row>
                                <div className="SaveCancelButtonDiv">
                                    <div className="container">
                                        <div className="row">
                                            <div className="text-right">
                                                {/* <button
                          type="button"
                          className="btn btn-primary float-end mx-2"
                        >
                          Cancel
                        </button> */}
                                                <button
                                                    type="button"
                                                    className="btn btn-success float-end"
                                                    onClick={(e) => errorCheck(e)}
                                                >
                                                    Proceed
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Form>
                </div>
            </div>
        </Container>
        <Modal
            show={showV}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="modal-header">
                <Modal.Title>Confirm Proceed</Modal.Title>
            </Modal.Header>
            {showMsgV == "" && (<Modal.Body>Please click on "Proceed" to Proceed.</Modal.Body>)}
            {showMsgV != "" && (<Modal.Body>
                <img src={CheckInimg} className="check-in-img" alt=""/> <br></br>
                <h5>Vendor details added Successfully !!</h5>
            </Modal.Body>)}
            <Modal.Footer>
                {showMsgV == "" && (<Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>)}
                {showMsgV != "" && (<Button variant="secondary" onClick={(e) => handleBack(e)}>
                    Back
                </Button>)}
                {showMsgV == "" && (<Button
                    type="button"
                    variant="primary"
                    onClick={(e) => handleSubmitForm(e)}
                >
                    Proceed
                </Button>)}
            </Modal.Footer>
        </Modal>
    </div>);
}

export default VendorMaster;
